import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

const FatalError = ({ message = "" }) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                verticalAlign: "middle",
                width: "100%",
                height: "100%"
            }}>
            <div
                style={{
                    width: "100%",
                    maxWidth: "480px",
                    padding: "40px",
                    borderRadius: "var(--radius-xl)",
                    background: "var(--glass-bg)",
                    backdropFilter: "var(--glass-blur)",
                    boxShadow: "var(--card-shadow)",
                    transition: "box-shadow var(--transition-medium), transform var(--transition-medium)",
                }}
                className="fatal-card"
            >
                <div style={{ textAlign: "center", marginBottom: "24px" }}>
                    <ExclamationCircleOutlined
                        style={{
                            fontSize: "54px",
                            color: "var(--brand)",
                            marginBottom: "12px",
                        }}
                    />
                    <h2
                        style={{
                            fontSize: "24px",
                            margin: 0,
                            color: "var(--text-primary)",
                            fontWeight: 700,
                        }}
                    >
                        Something went wrong
                    </h2>
                </div>

                <p
                    style={{
                        textAlign: "center",
                        color: "var(--text-secondary)",
                        lineHeight: 1.5,
                        marginBottom: "32px",
                        fontSize: "15px",
                    }}
                >
                    {message}
                </p>

                <Button
                    block
                    onClick={() => window.location = "/"}
                >
                    Back to Dashboard
                </Button>
            </div>

            <style>{`
                /* Add a soft hover lift to the card */
                .fatal-card:hover {
                    transform: translateY(-4px);
                    box-shadow: var(--card-shadow-hover);
                }
            `}</style>
        </div>
    );
}

export default FatalError;
